resultRow.$inject = [];

/**
 * @ngdoc    directive
 * @name     resultRow
 * @memberof csm.ui.importForm
 * @require  importForm
 * @restrict E
 *
 * @description
 * This is an informational directive to be referenced by the importForm
 * directive. This correlates to a row that that will display in the results table.
 * This row will be hidden if the hide expression evaluates to true.
 * As this is informational only, the element will be removed from the DOM.
 *
 * @attr {string}     text  Summary label to display
 * @attr {expression} hide  When true, the row is not shown. This expression can
 *                    access the current value by using $value.
 *******************************************************************************/
/* @ngInject */
export function resultRow() {
  return {
    restrict: 'E',
    require: '^^importForm',
    scope: { text: '@', hide: '&' },
    link: function (scope, elem, attr, ctrl) {
      ctrl.addResultRowScope(scope);
      elem.remove();
      scope.$on('$destroy', function () {
        ctrl.removeResultRowScope(scope);
      });
    }
  };
}
